/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RosterFieldType = {
    TEXT: 'TEXT',
    CHIP: 'CHIP',
    PERCENTAGE: 'PERCENTAGE',
    IMAGE: 'IMAGE',
    FLAG: 'FLAG'
} as const;
export type RosterFieldType = typeof RosterFieldType[keyof typeof RosterFieldType];


export function instanceOfRosterFieldType(value: any): boolean {
    for (const key in RosterFieldType) {
        if (Object.prototype.hasOwnProperty.call(RosterFieldType, key)) {
            if (RosterFieldType[key as keyof typeof RosterFieldType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RosterFieldTypeFromJSON(json: any): RosterFieldType {
    return RosterFieldTypeFromJSONTyped(json, false);
}

export function RosterFieldTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RosterFieldType {
    return json as RosterFieldType;
}

export function RosterFieldTypeToJSON(value?: RosterFieldType | null): any {
    return value as any;
}

export function RosterFieldTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): RosterFieldType {
    return value as RosterFieldType;
}

